var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4298 0H11.5704C9.25977 0 7.38477 1.875 7.38477 4.1875V59.8125C7.38477 62.125 9.25977 64 11.5703 64H52.4296C54.7421 64 56.6151 62.125 56.6151 59.8125V4.1875C56.6153 1.875 54.7423 0 52.4298 0ZM32.4923 61.373C31.4961 61.373 30.6875 60.5664 30.6875 59.5664C30.6875 58.5703 31.4961 57.7616 32.4923 57.7616C33.4903 57.7616 34.297 58.5703 34.297 59.5664C34.2969 60.5664 33.4903 61.373 32.4923 61.373ZM51.6914 55.1386H12.3086V4.92188H51.6915V55.1386H51.6914Z",
    fill: "#74747B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28.2656L32 23.7656L36.5 28.2656",
    stroke: "#0A49A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 23.7656V35.7656",
    stroke: "#0A49A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 38.7656C28.835 40.7156 35.165 40.7156 41 38.7656",
    stroke: "#0A49A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.7fd68c8677aecab0670ff975cc0225e7.svg";
export { ForwardRef as ReactComponent };